var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Avatar',{attrs:{"user":_vm.user,"message":_vm.message,"size":"small"}})}
var staticRenderFns = []

export { render, staticRenderFns }